// core/services/algolia/searchService.ts
// Simplified search service - works without Algolia configured
import { SocialProfile } from '../../types/social';
import { collection, query, where, getDocs, limit as firestoreLimit } from 'firebase/firestore';
import { db } from '../firebase/config';

export interface SearchResult {
  objectID: string;
  handle: string;
  displayName: string;
  bio?: string;
  location?: string;
  avatarUrl?: string;
  followers: number;
}

export const searchService = {
  /**
   * Search users by query (Firestore fallback)
   * TODO: Replace with Algolia when configured
   */
  async searchUsers(searchQuery: string, options?: {
    hitsPerPage?: number;
  }): Promise<SearchResult[]> {
    try {
      const searchTerm = searchQuery.toLowerCase();
      
      // Search by handle prefix
      const q = query(
        collection(db, 'profiles'),
        where('handle', '>=', searchTerm),
        where('handle', '<=', searchTerm + '\uf8ff'),
        firestoreLimit(options?.hitsPerPage || 20)
      );

      const snapshot = await getDocs(q);
      const results: SearchResult[] = snapshot.docs.map(doc => {
        const data = doc.data();
        return {
          objectID: data.handle,
          handle: data.handle,
          displayName: data.displayName,
          bio: data.bio,
          location: data.location ? `${data.location.city}, ${data.location.state}` : '',
          avatarUrl: data.avatarUrl,
          followers: data.stats?.followers || 0
        };
      });

      return results;
    } catch (error) {
      console.error('Search error:', error);
      return [];
    }
  },

  /**
   * Index a profile (no-op without Algolia)
   */
  async indexProfile(profile: any): Promise<void> {
    // No-op - will be implemented when Algolia is configured
    console.log('Algolia not configured - skipping index for:', profile.handle);
  },

  /**
   * Remove profile from index (no-op without Algolia)
   */
  async removeProfile(handle: string): Promise<void> {
    // No-op
  },

  /**
   * Batch index multiple profiles (no-op without Algolia)
   */
  async batchIndexProfiles(profiles: SocialProfile[]): Promise<void> {
    // No-op
  }
};
